import {tokenRegister} from "./tokenRegister";
import {salesChannelRegister} from "./salesChannelRegister";

class dataRegister {

    static api = {
        primehit: "https://api.devprimehit.com/v1",
        primehit2: "https://api.devprimehit.com/v2"
    };

    static stripe_key = salesChannelRegister.get('stripe_public_key');
    //static stripe_key = "pk_test_B9jdmNTexEN4un2OxcRiMKMk";

    static setApiDomain(value){
        if(value === "primehit" || value === "devprimehit"){
            dataRegister.api.primehit = "https://api."+value+".com/v1";
            dataRegister.api.primehit2 = "https://api."+value+".com/v2";
            dataRegister.stripe_key = salesChannelRegister.get('stripe_public_key');
            /*
            if(value === "primehit"){
                dataRegister.stripe_key = "pk_live_qcjyGkdLzPAqAubGOQ9wJKzN";

            }
            */
        }else{
            dataRegister.api.primehit = "http://"+value+"/v1";
            dataRegister.api.primehit2 = "http://"+value+"/v2";
        }
    }

    static salesChannel = "";

    static setSalesChannel(value){
        dataRegister.salesChannel = value;
    }

    static getSalesChannel(){
        return dataRegister.salesChannel;
    }

    static domain = "devsaleschannel.com";

    //static movie = "http://localhost:5000";
    static movie = "https://transparentpresence.com";

    static setDomain(value){
        if(value){
            dataRegister.domain = value;
        }
    }

    static getDomain(){
        return dataRegister.domain;
    }

    static documentLocation() {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            fetch(document.location, data)
                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static createVideo(info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.movie + "/adbop/video", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /*
    static uploadVideo(info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {},
                body: info
            };
            fetch(dataRegister.movie + "/adbop/upload/video", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
    */

    static createSlide(info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {},
                body: info
            };
            fetch(dataRegister.movie + "/adbop/upload/carousel", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static createCarousel(info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.movie + "/adbop/carousel", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static analyzeImage(image) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get()
                },
                body: image
            };
            fetch(dataRegister.api.primehit2 + "/image-analyzer", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static uploadVideo(video) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                body: video
            };
            fetch("https://transparentpresence.com/adbop/upload/video", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static checkCoupon(market, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit + '/' + market + "/account/coupon/" + id, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getIpWebsite(website) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            fetch("https://pro.ip-api.com/json/" + website+ "?key=IXve9OMOsXKH9Ir", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getSalesChannelData(market, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/static/salesforce/" + id, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getIndustryStrategies(market, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit + '/' + market + "/static/industry/" + id + "/strategies", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getImages(data) {
        let object = {
            industry: data.industry,
            market: data.market,
            page: data.page,
            amount: data.amount ? data.amount : 3
        };
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit2 + '/' + object.market + "/static/images/" + object.industry + "/" + object.page + "/" + object.amount, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getQuotes(industry, market, lang) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
            };
            fetch(dataRegister.api.primehit + "/" + market + "/" + lang + "/static/slogans/" + industry, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getIndustries(market, lang, query, limit) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            let string = dataRegister.api.primehit2 + "/" + market + "/" + lang + "/static/"+ salesChannelRegister.get('name') +"/industries";
            if(query){
                string = string + "?search=" + query + (limit?("&limit="+limit):"");
            }
            if(limit && !query){
                string = string + (limit?("?limit="+limit):"");
            }
            if(tokenRegister.get()){
                data.headers = {'Authorization': tokenRegister.get()}
            }
            fetch(string, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getRegions(market, regions) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
            };
            let url_string = "";
            if (regions) {
                url_string = dataRegister.api.primehit + "/" + market + "/static/region/" + regions;
            } else {
                url_string = dataRegister.api.primehit + "/" + market + "/static/region"
            }
            fetch(url_string, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getBudget(market, lang, saleschannel, industry, regions, related, duration, optimization_goal) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            fetch(dataRegister.api.primehit2 + "/" + market + "/" + lang + "/static/" + salesChannelRegister.get('name') +"/budget?campaign_duration="+duration+"&industry_id=" + industry + "&region_id=" + (regions ? encodeURIComponent(regions) : 0) + "&related=" + (related ? encodeURIComponent(related) : 0) + "&og=" + optimization_goal, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getMarkets(market, lang) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
            };
            fetch(dataRegister.api.primehit + "/" + market + "/" + lang + "/static/markets", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getRelatedIndustries(market, lang, industry) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            if(tokenRegister.get()){
                data.headers = {'Authorization': tokenRegister.get()}
            }
            fetch(dataRegister.api.primehit2 + "/" + market + "/" + lang + "/static/"+ salesChannelRegister.get('name') +"/industries/" + industry + "/related", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getLanguages() {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.server + '/languages', data)
                .then((response) => response.json())
                .then((responseJson) => {
                    if (responseJson.success) {
                        resolve(responseJson.data);
                    } else {
                        reject(responseJson);
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static checkPhone(market, phone) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            let url_string = dataRegister.api.primehit2 + "/" + market + "/number-check/" + phone;
            fetch(url_string, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getRegionsExtras(market, regions) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
            };
            let url_string = "";
            if (regions) {
                url_string = dataRegister.api.primehit + "/" + market + "/static/region/" + regions + '?salesforce=propertybooster';
            } else {
                url_string = dataRegister.api.primehit + "/" + market + "/static/region?salesforce=propertybooster"
            }
            fetch(url_string, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static archiveCampaign(market, lang, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': tokenRegister.get()
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + lang + "/campaign/" + id + '/archive', data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static signIn(market, user) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(user)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + salesChannelRegister.get('name') + "/login", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static signUp(market, user) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Referer': 'http://autopilot.primehit/enduser/general'
                },
                body: JSON.stringify(user)
            };
            fetch(dataRegister.api.primehit2 + '/' + market +"/"+ salesChannelRegister.get('name') + "/signup", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static createCampaign(market, campaign) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get()
                },
                body: campaign
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/createusercampaign", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static saveFacebookToken(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': tokenRegister.get()
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/save_facebook_token", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getCampaignsCount(market, lang) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/campaigns-count", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getCampaigns(market, lang, status) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + lang + "/campaigns/" + status, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getCampaign(market, lang, hash) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + lang + "/campaign/" + hash, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static terminateCampaign(market, hash) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/terminatecampaign/" + hash, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getInvoices(market, lang, page, per_page) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + lang + "/invoices?page=" + page + "&per_page=" + per_page, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getInvoice(market, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/invoice/" + id, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static sendForgotpassword(market, email) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(email)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + salesChannelRegister.get('name') + "/resetpassword", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static sendResetpassword(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + salesChannelRegister.get('name') + "/changepasswordwithpin", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static sendResetpasswordWithToken(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + salesChannelRegister.get('name') +  "/changepassword", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getPublicCampaigns(market) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/"+ salesChannelRegister.get('name') +"/randomcampaigns/3", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getTrendingIndustries(market) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + salesChannelRegister.get('name') + "/mostpopularindustries/5", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getAccount(market) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit + '/' + market + "/account", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getSettlements(market, reseller) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            let url = dataRegister.api.primehit + '/' + market + "/account/resellerreports";
            if(reseller){
                url = url + "/" + reseller;
            }
            fetch(url, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static setSettlement(market, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get()
                },
            };
            fetch(dataRegister.api.primehit + '/' + market + "/account/resellerreports/" + id + "/approve", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static postAccount(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit + '/' + market + "/account", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static postProfileImage(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                },
                body: info
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/profileimage", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static referAccount(market, account) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(account)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + salesChannelRegister.get('name') + "/refer", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static referredAccounts(market) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/referrals", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static sendIndustryRequest(market, saleschannel, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + saleschannel + "/contact", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static setRenew(market, hash, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/updatecampaign/" + hash, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static setStatusLanding(market, id, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit + '/' + market + "/customers/" + id + "/lp", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static getInsights(market) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/insights", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static getToken(market, hash) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit + '/' + market + "/account/token/" + hash, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static getFacebookTargeting(market, type, phrase) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            fetch("https://api.primehit.com/v2" + '/' + market + "/facebooktargetingsearch?type=" + type + "&phrase=" + phrase, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static images(data) {
        return dataRegister.getImages(data);
    }

    static quotes(industry, market, lang) {
        return dataRegister.getQuotes(industry, market, lang);
    }

    static industries(market, lang, query, limit) {
        return dataRegister.getIndustries(market, lang, query, limit);
    }

    static regions(market, regions) {
        return dataRegister.getRegions(market, regions);
    }

    static budget(market, lang, saleschannel, industry, regions, related, duration, og) {
        return dataRegister.getBudget(market, lang, saleschannel, industry, regions, related, duration, og);
    }

    static related(market, lang, industry) {
        return dataRegister.getRelatedIndustries(market, lang, industry);
    }

    static languages() {
        return dataRegister.getLanguages();
    }

    static login(market, data) {
        return dataRegister.signIn(market, data);
    }

    static register(data) {
        return dataRegister.signUp(data);
    }

    static campaign(market, campaign) {
        return dataRegister.createCampaign(market, campaign);
    }

    static campaigns(market, lang, status) {
        return dataRegister.getCampaigns(market, lang, status);
    }

    static singleCampaign(market, lang, id) {
        return dataRegister.getCampaign(market, lang, id);
    }

    static invoices(market, lang) {
        return dataRegister.getInvoices(market, lang);
    }

    static invoice(market, id) {
        return dataRegister.getInvoice(market, id);
    }

    static forgotPassword(market, data) {
        return dataRegister.sendForgotpassword(market, data);
    }

    static resetPassword(market, data) {
        return dataRegister.sendResetpassword(market, data);
    }

    static resetPasswordToken(market, data) {
        return dataRegister.sendResetpasswordWithToken(market, data);
    }

    static publicCampaigns(market) {
        return dataRegister.getPublicCampaigns(market);
    }

    static trendingIndustries(market) {
        return dataRegister.getTrendingIndustries(market);
    }

    static account(market) {
        return dataRegister.getAccount(market);
    }

    static editAccount(market, info) {
        return dataRegister.postAccount(market, info);
    }

    static refer(market, account) {
        return dataRegister.referAccount(market, account);
    }

    static referred(market){
        return dataRegister.referredAccounts(market);
    }

    static industryRequest(market, saleschannel, info){
        return dataRegister.sendIndustryRequest(market, saleschannel,    info);
    }

    static renew(market, hash, info){
        return dataRegister.setRenew(market, hash, info);
    }

    static insights(market){
        return dataRegister.getInsights(market);
    }

    static settlements(market){
        return dataRegister.getSettlements(market);
    }

    static approve(market, id){
        return dataRegister.setSettlement(market, id);
    }

    static userToken(market, hash){
        return dataRegister.getToken(market, hash);
    }

    static facebookTargeting(market, type, phrase){
        return dataRegister.getFacebookTargeting(market, type, phrase);
    }

}

export {dataRegister}


// WEBPACK FOOTER //
// ./src/services/dataRegister.js